import { Directive, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { CheckoutStepComponentDef } from '@df/checkout/checkout-step.component.def';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { SessionStorage } from '@df/browser/storage/decorator/session-storage';
import { IResponseMeta, IResponseMetaResultRedirect } from '@df/api/request/request.service';
import { Status } from '@df/core/status';

@Directive()
export abstract class CheckoutConfirmationComponentDef extends CheckoutStepComponentDef implements Checkout.IStep, OnInit, OnDestroy {
    override readonly name = Checkout.CHECKOUT_CONFIRMATION_STEP_NAME;

    readonly hidden = true;

    override readonly order = Infinity;

    isConfirmation = true;

    protected requestServiceSubscription: Subscription;

    @ViewChild('container')
    containerElementRef: ElementRef;

    @SessionStorage('checkoutConfirmation')
    protected checkoutConfirmation: IResponseMetaResultRedirect | undefined;

    readonly status = new Status();

    override ngOnInit() {
        super.ngOnInit();

        this.requestServiceSubscription = this.app.request.subscribe((response: IResponseMeta) => {
            const result = response.result as Checkout.ISubmissionResponse;
            if (result?.post_redirect) {
                const redirect = result.post_redirect;
                const { modal, action, data } = redirect;
                if (modal && action) {
                    this.checkoutConfirmation = redirect;
                    // remove from result not to allow other methods use it
                    result.post_redirect = undefined;
                    result.external_redirect = undefined;
                    // set flag to prevent checkout redirect to success page
                    result.preventSuccess = true;
                    this.embed(action, data);
                    return;
                }
            }
        }, 10);
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        if (this.requestServiceSubscription) {
            this.requestServiceSubscription.unsubscribe();
        }
    }

    /**
     * Embed post request in iframe
     * @param {string}  action  - post action
     * @param {any}     data    - post data
     */
    protected embed(action: string, data: any): void {
        this.status.busy = true;
        const containerElement = this.getContainerElement();
        if (containerElement) {
            this.app.request.postLikeForm(action, data, {
                target: this.name,
                container: containerElement
            });
            this.checkoutFormComponent.confirmationLock = this;
        } else {
            this.logger.error('Checkout confirmation iframe does not exist');
            this.app.request.postLikeForm(action, data);
        }
    }

    /**
     * Returns container element
     * @returns {Element | undefined}
     */
    protected getContainerElement(): Element | undefined {
        return this.containerElementRef?.nativeElement;
    }

    protected override isValid(): true {
        return true;
    }
}
